module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-UltraBoldItalic.10594ae.woff2";